import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import {
  insertPlanCategories,
  setSelectedCategorySlug
} from '../../../../redux/actions/planCategories'
import {
  setProductOrder,
  addCategoryOption,
  addSubcategoryFilter,
  replaceProductFilters,
  applyCategoryFilter,
  // setDifficultyFilter,
  // setIntensityFilter,
  clearAllSeriesFilters,
  addSeriesFilter,
  setDefaultFilter
} from '../../../../redux/actions/products/filters'
import { loadProductsPage } from '../../../../redux/actions/products/products'
import { getSubcategories } from '../../../../redux/selectors/planSubcategories'
import {
  getCategories,
  getLastSelectedCategory
} from '../../../../redux/selectors/planCategories'

import ProductsDisplay from '../../../productsComponents/productsDisplay/ProductsDisplay'
import ExploreNav from '../exploreNav/ExploreNav'
import GreyPageHeader from '../../../GreyPageHeader'
import CategoryBanner from '../exploreNav/CategoryBanner'
import { pageTitle, pageCaption } from '../ExploreHeaders'
import { getCategoryObj, getSubcategoryObj } from './exploreFilterHelpers'
import SeriesFinderNewFilteredList from '../exploreNav/SeriesFinderNewFilteredList'
import isEqual from 'lodash.isequal'

class ExploreFilterWrapper extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      layout: window.localStorage.getItem('layout'),
      mobile: window.innerWidth < 768
    }

    this.pushWindowState = this.pushWindowState.bind(this)
    this.initializePage = this.initializePage.bind(this)

    props.insertPlanCategoriesToTree()
    props.setSelectedCategorySlug()
    this.initializePage()
  }

  componentDidMount() {
    window.onresize = () => {
      const windowWidth = window.innerWidth
      if (windowWidth < 768 && !this.state.mobile) {
        this.setState({ mobile: true })
      } else if (windowWidth >= 768 && this.state.mobile) {
        this.setState({ mobile: false })
      }
    }
  }

  getCategoryObjectFromUrl = () => {
    let categoryObject = {
      yoga: [],
      mindfulness: [],
      fitness: [],
      wellness: [],
      skills: []
    }
    const urlParams = new URLSearchParams(window.location.search)
    const categoriesValue = urlParams.get('categories')
    const categoryArray = categoriesValue?.split(',')
    categoryArray?.forEach((category) => {
      const slugInfo = category.split('_')
      const isASubcategory = slugInfo.length > 1

      const slug = isASubcategory ? slugInfo[1] : slugInfo[0]

      if (isASubcategory) {
        const parentSlug = slugInfo[0]
        const parentCategoryObj = getCategoryObj(
          this.props.categoryOptions,
          parentSlug
        )
        if (!parentCategoryObj) {
          return
        }
        const subcategory = getSubcategoryObj(
          parentCategoryObj.subcategories,
          category
        )
        if (!subcategory) {
          return
        }

        categoryObject[parentSlug] = [...(categoryObject[slug] || []), category]
      } else {
        categoryObject[slug] = 'all'
      }
    })
    return categoryObject
  }

  componentDidUpdate(prevProps) {
    const prevParams = new URLSearchParams(prevProps?.filterUrl)
    const currentParams = new URLSearchParams(window.location.search)
    if (prevParams?.get('categories') !== currentParams?.get('categories')) {
      // 'page' param changed specifically
      const categoryObject = this.getCategoryObjectFromUrl()

      if (
        (categoryObject?.yoga.length &&
          !isEqual(
            this.props.filters?.categories?.yoga,
            categoryObject?.yoga
          )) ||
        (categoryObject?.fitness.length &&
          !isEqual(
            this.props.filters?.categories?.fitness,
            categoryObject?.fitness
          )) ||
        (categoryObject?.mindfulness.length &&
          !isEqual(
            this.props.filters?.categories?.mindfulness,
            categoryObject?.mindfulness
          )) ||
        (categoryObject?.wellness.length &&
          !isEqual(
            this.props.filters?.categories?.wellness,
            categoryObject?.wellness
          )) ||
        (categoryObject?.skills.length &&
          !isEqual(
            this.props.filters?.categories?.skills,
            categoryObject?.skills
          ))
      ) {
        this.initializePage()
      }
    }
  }

  componentWillUnmount() {
    this.props.clearAllSeriesFilters()
    this.props.setDefaultFilter({})
  }

  initializePage() {
    if (this.props.defaultValue) {
      this.props.setDefaultFilter({
        instructors: this.props.filteredInstructors || []
      })
    }
    this.props.setProductOrder(this.props.defaultOrder)

    this.props.categoryOptions.forEach((category) => {
      this.props.addCategoryOption(category.slug)
    })

    if (!this.props.defaultValue) {
      const params = new URLSearchParams(window.location.search)
      params.forEach((value, key) => {
        if (
          [
            'focus_area',
            'equipment',
            'difficulties',
            'intensities',
            'excludeCompleted'
          ].includes(key)
        ) {
          const FilterArray = value.split(',')
          FilterArray.forEach((category) => {
            this.props.addSeriesFilter(key, category)
          })
        } else if (key === 'instructors') {
          const FilterArray = value.split(',')
          FilterArray.forEach((category) => {
            const instructor = this.props.instructorOptions?.find(
              (item) => item.slug === category
            )
            this.props.addSeriesFilter('instructors', instructor)
          })
        } else if (key === 'categories') {
          const categoryArray = value.split(',')
          categoryArray.forEach((category) => {
            const slugInfo = category.split('_')
            const isASubcategory = slugInfo.length > 1

            const slug = isASubcategory ? slugInfo[1] : slugInfo[0]

            if (isASubcategory) {
              const parentSlug = slugInfo[0]
              const parentCategoryObj = getCategoryObj(
                this.props.categoryOptions,
                parentSlug
              )
              if (!parentCategoryObj) {
                return
              }
              const subcategory = getSubcategoryObj(
                parentCategoryObj.subcategories,
                category
              )
              if (!subcategory) {
                return
              }
              const title = subcategory.title
              this.props.addSubcategoryFilter(parentSlug, {
                slug: category,
                title
              })
            } else {
              this.props.applyCategoryFilter(slug)
            }
          })
        }
      })
    }

    // this.props.setDifficultyFilter(this.props.difficulty)
    // this.props.setIntensityFilter(this.props.intensity)

    this.props.loadProductPage(true, () => {
      window.history.replaceState(
        this.props.filters,
        null,
        this.props.defaultValue
          ? `${this.props.baseUrl}?${this.props.filterUrl}`
          : `${this.props.baseUrl}/filter?${this.props.filterUrl}`
      )
    })
  }

  renderPageBanner() {
    const lastFilteredCategory = this.props.lastSelectedCategory

    if (lastFilteredCategory && this.state.mobile) {
      return <CategoryBanner category={lastFilteredCategory} />
    } else {
      return <GreyPageHeader title={pageTitle} caption={pageCaption} />
    }
  }

  pushWindowState() {
    window.history.pushState(
      this.props.filters,
      null,
      this.props.defaultValue
        ? `${this.props.baseUrl}?${this.props.filterUrl}`
        : `${this.props.baseUrl}/filter?${this.props.filterUrl}`
    )
  }

  setOrder(order) {
    this.setState({ order })
    this.props.setProductOrder(order)
    this.props.loadProductPage(true, this.pushWindowState)
  }

  selectLayout(layout) {
    this.setState({ layout: layout })
  }

  render() {
    let productDisplayProps = {
      category: this.props.currCategorySlug,
      layout: this.state.layout,
      baseUrl: this.props.baseUrl,
      group: this.props.group,
      order: this.props.filters.order,
      difficulty: this.props.difficulty,
      intensity: this.props.intensity,
      total: this.props.total,
      onAfterProductLoad: this.pushWindowState
    }

    return (
      <React.Fragment>
        {this.renderPageBanner()}
        {window.innerWidth > 1024 ? (
          <SeriesFinderNewFilteredList
            initialize={this.initializePage}
            order={this.props.filters.order}
            group={this.props.group}
            onSort={this.setOrder.bind(this)}
            selectLayout={this.selectLayout.bind(this)}
            layout={this.state.layout}
            filters={this.props.filters}
            totalProducts={this.props.total}
            onAfterProductLoad={this.pushWindowState}
            difficulty={this.props.difficulty}
            intensity={this.props.intensity}
          />
        ) : null}
        <div className='ExploreFilterPage container-fluid'>
          <ExploreNav
            initialize={this.initializePage}
            order={this.props.filters.order}
            group={this.props.group}
            onSort={this.setOrder.bind(this)}
            selectLayout={this.selectLayout.bind(this)}
            layout={this.state.layout}
            filters={this.props.filters}
            totalProducts={this.props.total}
            onAfterProductLoad={this.pushWindowState}
            instructorOptions={this.props.instructorOptions}
            equipmentTags={this.props.equipmentTags}
            focusAreaTags={this.props.focusAreaTags}
            currentUser={this.props.currentUser}
          />
          <div className='ExploreFilterPage__contentContainer'>
            <ProductsDisplay {...productDisplayProps} />
          </div>
        </div>
      </React.Fragment>
    )
  }
}

ExploreFilterWrapper.propTypes = {
  baseUrl: PropTypes.string,
  defaultOrder: PropTypes.string,
  categoryOptions: PropTypes.array
}

const mapStateToProps = (state) => ({
  categories: getCategories(state),
  filterUrl: state.ui.products.filterUrl,
  filters: state.ui.products.filters,
  total: parseInt(state.ui.products.total),
  subcategoryOptions: getSubcategories(state),
  lastSelectedCategory: getLastSelectedCategory(state)
})

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    addCategoryOption: (slug) => {
      dispatch(addCategoryOption(slug))
    },
    addSubcategoryFilter: (parentCategory, subcategory) => {
      dispatch(addSubcategoryFilter(parentCategory, subcategory))
    },
    insertPlanCategoriesToTree: () => {
      dispatch(insertPlanCategories(ownProps.categoryOptions))
    },
    setSelectedCategorySlug: () => {
      dispatch(setSelectedCategorySlug(ownProps.prefilteredCategories[0]))
    },
    setProductOrder: (order) => {
      dispatch(setProductOrder(order))
    },
    loadProductPage: (reloadAll, callback) => {
      dispatch(loadProductsPage(reloadAll, callback))
    },
    replaceProductFilters: (newFilters) => {
      dispatch(replaceProductFilters(newFilters))
    },
    applyCategoryFilter: (category) => {
      dispatch(applyCategoryFilter(category))
    },
    addSeriesFilter: (parentCategory, filter) => {
      dispatch(addSeriesFilter(parentCategory, filter))
    },
    setDefaultFilter: (value) => {
      dispatch(setDefaultFilter(value))
    },
    clearAllSeriesFilters: () => {
      dispatch(clearAllSeriesFilters())
    }
    // setDifficultyFilter: (difficulty) => {
    //   dispatch(setDifficultyFilter(difficulty))
    // },
    // setIntensityFilter: (intensity) => {
    //   dispatch(setIntensityFilter(intensity))
    // }
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ExploreFilterWrapper)
